import {
  errorLoading,
  loaded,
  //  loading,
  progress,
  uploading,
  endUploading,
  responseHandler,
  tokenInterceptor,
  errorGetStatus,
} from '../manager/HttpManager'
import { fetchLogoutAction } from './AuthWS'
import Constants from '../constants/Constants'

let urlServer = Constants.UrlsConstants.urlServer
let page = 1
let maxPage = 1
let limit = 50
let isFetchingMedias = false
let isTagFiltering = false
let pageIcon = 1
let maxPageIcon = 1
let limitIcon = 100
let isFetchingIcons = false

let pageImage = 1
let maxPageImage = 1
let limitImage = 100
let isFetchingImages = false

export const libraryWS = (state = {
  medias: [], mediasTags: [], selectedMediaTags: [], mediasSize: [], progress: -1, uploadState: '',
  icons: [], iconsTags: [], images: [], imagesTags: [],
  totalSize: 0, isReplacing: false,
}, action) => {
  switch (action.type) {
    case Constants.ActionsConstants.LIBRARY.SET_MEDIAS:
      return Object.assign({}, state, { medias: state.medias.concat(action.datas.content) })
    case Constants.ActionsConstants.LIBRARY.SET_MEDIAS_FILTERED:
      return Object.assign({}, state, { medias: action.datas.content })
    case Constants.ActionsConstants.LIBRARY.CLEAR_MEDIAS:
      return Object.assign({}, state, { medias: [] })
    case Constants.ActionsConstants.LIBRARY.UPLOAD_PROGRESS:
      return Object.assign({}, state, { progress: action.datas })
    case Constants.ActionsConstants.LIBRARY.UPLOAD_SUCCESS:
      return Object.assign({}, state, { uploadState: 'SUCCESS' })
    case Constants.ActionsConstants.LIBRARY.UPLOAD_REINIT_STATUS:
      return Object.assign({}, state, { uploadState: '' })
    case Constants.ActionsConstants.LIBRARY.SET_ICONS_TAG:
      return Object.assign({}, state, { iconsTags: action.datas })
    case Constants.ActionsConstants.LIBRARY.SET_MEDIAS_TAG:
      return Object.assign({}, state, { mediasTags: action.datas })
    case Constants.ActionsConstants.LIBRARY.SET_MEDIAS_TAG_SELECTED:
      return Object.assign({}, state, { selectedMediaTags: action.datas })
    case Constants.ActionsConstants.LIBRARY.SET_ICONS:
      return Object.assign({}, state, { icons: state.icons.concat(action.datas.content) })
    case Constants.ActionsConstants.LIBRARY.RESET_ICONS:
      pageIcon = 1
      maxPageIcon = 1
      return Object.assign({}, state, { icons: [] })
    case Constants.ActionsConstants.LIBRARY.SET_IMAGES_TAG:
      return Object.assign({}, state, { imagesTags: action.datas })
    case Constants.ActionsConstants.LIBRARY.SET_IMAGES:
      return Object.assign({}, state, { images: state.images.concat(action.datas.content) })
    case Constants.ActionsConstants.LIBRARY.RESET_IMAGES:
      pageImage = 1
      maxPageImage = 1
      return Object.assign({}, state, { images: [] })
    case Constants.ActionsConstants.LIBRARY.SET_TOTAL_SIZE:
      return Object.assign({}, state, { totalSize: action.data })
    case Constants.ActionsConstants.LIBRARY.SET_REPLACING:
      return Object.assign({}, state, { isReplacing: action.data })
    case Constants.ActionsConstants.LIBRARY.UPDATE_MEDIA:
      let mediasSize = JSON.parse(JSON.stringify(state.mediasSize))
      let findIndexSize = mediasSize.findIndex(m => m.id === action.data.id)
      if (findIndexSize === -1) mediasSize.push(action.data)
      return Object.assign({}, state, { mediasSize })
    case Constants.ActionsConstants.LIBRARY.UPDATE_MEDIA_TAGS:
      let medias = JSON.parse(JSON.stringify(state.medias))
      let findIndex = medias.findIndex(m => m.id === action.data.id)
      if (findIndex !== -1) medias[findIndex].tags = action.data.tags
      return Object.assign({}, state, { medias })
    default:
      return state
  }
}

export const setMedias = (data) => {
  return {
    type: Constants.ActionsConstants.LIBRARY.SET_MEDIAS,
    datas: data,
  }
}

export const setMediasFiltered = (data) => {
  return {
    type: Constants.ActionsConstants.LIBRARY.SET_MEDIAS_FILTERED,
    datas: data,
  }
}

export const setIcons = (data) => {
  return {
    type: Constants.ActionsConstants.LIBRARY.SET_ICONS,
    datas: data,
  }
}

export const resetIcons = () => {
  return {
    type: Constants.ActionsConstants.LIBRARY.RESET_ICONS,
    datas: [],
  }
}

export const setIconsTags = (data) => {
  return {
    type: Constants.ActionsConstants.LIBRARY.SET_ICONS_TAG,
    datas: data,
  }
}

export const setMediasTags = (data) => {
  return {
    type: Constants.ActionsConstants.LIBRARY.SET_MEDIAS_TAG,
    datas: data,
  }
}

export const setSelectedMediaTags = (data) => {
  return {
    type: Constants.ActionsConstants.LIBRARY.SET_MEDIAS_TAG_SELECTED,
    datas: data,
  }
}

export const setImagesTags = (data) => {
  return {
    type: Constants.ActionsConstants.LIBRARY.SET_IMAGES_TAG,
    datas: data,
  }
}

export const setImages = (data) => {
  return {
    type: Constants.ActionsConstants.LIBRARY.SET_IMAGES,
    datas: data,
  }
}

export const resetImages = () => {
  return {
    type: Constants.ActionsConstants.LIBRARY.RESET_IMAGES,
    datas: [],
  }
}
export const setTotalSize = (totalSize) => {
  return {
    type: Constants.ActionsConstants.LIBRARY.SET_TOTAL_SIZE,
    data: totalSize,
  }
}
export const setReplacing = (isReplacing) => {
  return {
    type: Constants.ActionsConstants.LIBRARY.SET_REPLACING,
    data: isReplacing,
  }
}
export const updateMedia = (data) => {
  return {
    type: Constants.ActionsConstants.LIBRARY.UPDATE_MEDIA,
    data,
  }
}
export const updateMediaTags = (data) => {
  return {
    type: Constants.ActionsConstants.LIBRARY.UPDATE_MEDIA_TAGS,
    data,
  }
}

export function fetchMediasActions(dispatch, appid = null, fileid = null, categoryName = null,
  mediaTypes, imageId, file = null, mediasSize = [], getSizes = false, tags = null) {
  function fetchMedias() {
    let wasTagFiltering = false
    if (tags) {
      page = 1
      isTagFiltering = true
    }
    if (!tags && isTagFiltering) {
      page = 1
      isTagFiltering = false
      wasTagFiltering = true
    }
    if (appid && !isFetchingMedias && page <= maxPage) {
      isFetchingMedias = true
      let entryPoint = Constants.UrlsConstants.libraryEntryPoint
      let method = Constants.MethodsWSConstants.MEDIAS.FETCH_MEDIAS + appid

      let types = ''
      if (mediaTypes) {
        types = '&types=' + mediaTypes.join('+')
      }
      let tagsEntry = ''
      if (tags) {
        tagsEntry = `&tags=${tags}`
      }

      if (page <= maxPage) {
        fetch(urlServer + entryPoint + method + '?page=' + page + '&size=' + limit +
          '&sort=creation&dir=DESC' + types + tagsEntry, {
          method: 'GET',
          headers: Constants.UrlsConstants.header,
        })
          .then(response => {
            tokenInterceptor(response)
            return responseHandler(response)
          })
          .then(r => r.json())
          .then(data => {
            maxPage = data.totalPages
            if (maxPage >= page) page++
            if (tags || wasTagFiltering) dispatch(setMediasFiltered(data)); else dispatch(setMedias(data))
            isFetchingMedias = false
            fetch(Constants.UrlsConstants.urlServer + Constants.UrlsConstants.mediaTotalSize + appid, {
              method: 'GET',
              headers: Constants.UrlsConstants.header,
            })
              .then(response => {
                tokenInterceptor(response)
                return responseHandler(response)
              }).then(r => r.json())
              .then(data => dispatch(setTotalSize(data.totalSize)))
            if (getSizes) {
              for (let i = 0; i < data.content.length; i++) {
                if (!mediasSize.length || mediasSize.findIndex(ms => ms.id === data.content[i].id) === -1) {
                  fetch(Constants.UrlsConstants.urlServer + Constants.UrlsConstants.mediaContent +
                    data.content[i].id + Constants.UrlsConstants.authTokenParam).then(res => {
                      dispatch(updateMedia({
                        id: data.content[i].id,
                        size: parseInt(res.headers.get('Content-Length'), 10),
                      }))
                    })
                }
              }
            }
          })
          .catch(error => {
            isFetchingMedias = false
            if (errorGetStatus(error) === 401) {
              dispatch(errorLoading('Error.Croutons.authExpired'))
              fetchLogoutAction(dispatch).fetchLogout()
            }
          })
      }
    }
  }

  function updateSelectedMediaTags(data) {
    dispatch(setSelectedMediaTags(data))
  }

  function fetchIconsTags() {
    let entryPoint = Constants.UrlsConstants.iconsTagsEntryPoint
    fetch(urlServer + entryPoint, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setIconsTags(data))
      })
      .catch(error => {
        // dispatch(errorLoading('icons'))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        }
      })
  }
  function addTagToMedia(id, tags) {
    let entryPoint = Constants.UrlsConstants.mediaTags
    fetch(urlServer + entryPoint, {
      method: 'PUT',
      headers: Constants.UrlsConstants.header,
      body: JSON.stringify({
        id,
        tags,
      }),
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(updateMediaTags({
          id: data.id,
          tags: data.tags,
        }))
        fetchMediasActions(dispatch, appid).fetchMediasTags()
      })
  }
  function fetchMediasTags() {
    let entryPoint = Constants.UrlsConstants.mediaTags + '/' + appid
    fetch(urlServer + entryPoint, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setMediasTags(data))
      })
      .catch(error => {
        // dispatch(errorLoading('icons'))
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
          // window.location.href='/'
        }
      })
  }

  function searchIcons() {
    if (!isFetchingIcons && pageIcon <= maxPageIcon && categoryName.length) {
      isFetchingIcons = true
      // eslint-disable-next-line no-useless-escape
      let tags = categoryName.replace(/\ /g, '+')
      let entryPoint = Constants.UrlsConstants.iconsSearchTagsEntryPoint +
        '?tags=' + tags + '&page=' + pageIcon + '&size=' + limitIcon
      fetch(urlServer + entryPoint, {
        method: 'GET',
        headers: Constants.UrlsConstants.header,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          // dispatch(loaded('icons'))
          isFetchingIcons = false
          maxPageIcon = data.totalPages
          if (maxPageIcon >= pageIcon) pageIcon++
          dispatch(setIcons(data))
        })
        .catch(error => {
          isFetchingIcons = false
          // dispatch(errorLoading('icons'))
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
            // window.location.href='/'
          }
        })
    }
  }

  function fetchIcons() {
    if (!isFetchingIcons && pageIcon <= maxPageIcon) {
      isFetchingIcons = true
      let entryPoint = Constants.UrlsConstants.iconsEntryPoint + categoryName + '?page=' +
        pageIcon + '&size=' + limitIcon
      fetch(urlServer + entryPoint, {
        method: 'GET',
        headers: Constants.UrlsConstants.header,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          // dispatch(loaded('icons'))
          isFetchingIcons = false
          maxPageIcon = data.totalPages
          if (maxPageIcon >= pageIcon) pageIcon++
          dispatch(setIcons(data))
        })
        .catch(error => {
          isFetchingIcons = false
          // dispatch(errorLoading('icons'))
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
            // window.location.href='/'
          }
        })
    }
  }

  function clearIcons() {
    dispatch(resetIcons())
  }

  function fetchImagesTags() {
    let entryPoint = Constants.UrlsConstants.imagesTagsEntryPoint
    fetch(urlServer + entryPoint, {
      method: 'GET',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setImagesTags(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function searchImages() {
    if (!isFetchingImages && pageImage <= maxPageImage && categoryName.length) {
      isFetchingImages = true
      // eslint-disable-next-line no-useless-escape
      let tags = categoryName.replace(/\ /g, '+')
      let entryPoint = Constants.UrlsConstants.imagesSearchTagsEntryPoint +
        '?tags=' + tags + '&page=' + pageImage + '&size=' + limitImage
      fetch(urlServer + entryPoint, {
        method: 'GET',
        headers: Constants.UrlsConstants.header,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          isFetchingImages = false
          maxPageImage = data.totalPages
          if (maxPageImage >= pageImage) pageImage++
          dispatch(setImages(data))
        })
        .catch(error => {
          isFetchingImages = false
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          }
        })
    }
  }

  function fetchImages() {
    if (!isFetchingImages && pageImage <= maxPageImage) {
      isFetchingImages = true
      let entryPoint = Constants.UrlsConstants.imagesEntryPoint + categoryName +
        '?page=' + pageImage + '&size=' + limitImage
      fetch(urlServer + entryPoint, {
        method: 'GET',
        headers: Constants.UrlsConstants.header,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          isFetchingImages = false
          maxPageImage = data.totalPages
          if (maxPageImage >= pageImage) pageImage++
          dispatch(setImages(data))
        })
        .catch(error => {
          isFetchingImages = false
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          }
        })
    }
  }

  function addImageToMedias() {
    let entryPoint = Constants.UrlsConstants.libraryEntryPoint
    let url = urlServer + entryPoint + 'add/' + appid + '/' + imageId
    fetch(url, {
      method: 'POST',
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        clearMediasActions(dispatch).clearMediasFromStore()
        fetchMediasActions(dispatch, appid).fetchMedias()
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  function clearImages() {
    dispatch(resetImages())
  }

  function replaceFile() {
    if (fileid && file) {
      let entryPoint = Constants.UrlsConstants.mediaEntryPoint
      let method = fileid
      let formData = new FormData()
      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
      }
      formData.append('file', file)
      if (file.type === 'application/pdf') {
        formData.append('typeMedia', Constants.AppsConstants.MEDIA.TYPE[1])
      } else if (file.type === 'video/mp4') {
        formData.append('typeMedia', Constants.AppsConstants.MEDIA.TYPE[2])
      } else if (file.type.indexOf('image/') !== -1) {
        formData.append('typeMedia', Constants.AppsConstants.MEDIA.TYPE[0])
      }
      clearMediasActions(dispatch).clearMediasFromStore()
      dispatch(uploading())
      dispatch(setReplacing(true))

      fetch(urlServer + entryPoint + method, {
        method: 'PUT',
        body: formData,
        headers,
      })
        .then(res => progress(res.body, res))
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(data => {
          dispatch(setReplacing(false))
          dispatch(loaded('Error.Croutons.uploadSuccess'))
          dispatch(uploadSuccess())
          dispatch(endUploading())
          fetchMediasActions(dispatch, appid).fetchMedias()
        })
        .catch(error => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          } else {
            dispatch(errorLoading('Error.Croutons.uploadFail'))
          }
        })
    }
  }
  function deleteFile() {
    if (fileid) {
      let entryPoint = Constants.UrlsConstants.mediaEntryPoint
      let method = fileid

      // dispatch(loading(method))
      fetch(urlServer + entryPoint + method, {
        method: 'DELETE',
        headers: Constants.UrlsConstants.header,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(data => {
          dispatch(loaded('Error.Croutons.deleteSuccess'))
          clearMediasActions(dispatch).clearMediasFromStore()
          fetchMediasActions(dispatch, appid).fetchMedias()
        })
        .catch(error => {
          // dispatch(errorLoading(method))
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
            // window.location.href='/'
          } else {
            dispatch(errorLoading('Error.Croutons.deleteError'))
          }
        })
    }
  }

  return {
    fetchMedias,
    fetchMediasTags,
    addTagToMedia,
    fetchIconsTags,
    fetchIcons,
    searchIcons,
    clearIcons,
    fetchImagesTags,
    searchImages,
    fetchImages,
    addImageToMedias,
    clearImages,
    deleteFile,
    replaceFile,
    updateSelectedMediaTags
  }
}

export const clearMedias = () => {
  return {
    type: Constants.ActionsConstants.LIBRARY.CLEAR_MEDIAS,
    datas: null,
  }
}

export function clearMediasActions(dispatch) {
  function clearMediasFromStore() {
    page = 1
    maxPage = 1
    dispatch(clearMedias())
  }

  return {
    clearMediasFromStore,
  }
}

export const uploadProgress = (data) => {
  return {
    type: Constants.ActionsConstants.LIBRARY.UPLOAD_PROGRESS,
    datas: data,
  }
}

export const uploadSuccess = () => {
  return {
    type: Constants.ActionsConstants.LIBRARY.UPLOAD_SUCCESS,
  }
}

export const uploadReinit = () => {
  return {
    type: Constants.ActionsConstants.LIBRARY.UPLOAD_REINIT_STATUS,
  }
}
export function UploadMediaAction(dispatch, file = null, appid = null, filename = null) {
  function upload() {
    if (appid && file) {
      let entryPoint = Constants.UrlsConstants.libraryEntryPoint
      let method = Constants.MethodsWSConstants.MEDIAS.ADD_MEDIA + appid
      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
      }
      dispatch(uploading())

      let uploadPromise = Promise.resolve()
      file.forEach((fileToUpload) => {
        uploadPromise = uploadPromise.then(() => {
          let formData = new FormData()
          formData.append('file', fileToUpload)
          if (fileToUpload.type === 'application/pdf') {
            formData.append('typeMedia', Constants.AppsConstants.MEDIA.TYPE[1])
          } else if (fileToUpload.type === 'video/mp4') {
            formData.append('typeMedia', Constants.AppsConstants.MEDIA.TYPE[2])
          } else if (fileToUpload.type.indexOf('image/') !== -1) {
            formData.append('typeMedia', Constants.AppsConstants.MEDIA.TYPE[0])
          }
          return fetch(urlServer + entryPoint + method, {
            method: 'POST',
            body: formData,
            headers,
          })
            .then(res => progress(res.body, res))
            .then(response => {
              tokenInterceptor(response)
              return responseHandler(response)
            })
            .then(r => r.json())
            .catch(() => {
              uploadPromise.reject()
            })
        })
      })
      uploadPromise = uploadPromise.then(() => {
        dispatch(loaded('Error.Croutons.uploadSuccess'))
        dispatch(uploadSuccess())
        dispatch(endUploading())
        clearMediasActions(dispatch).clearMediasFromStore()
        fetchMediasActions(dispatch, appid).fetchMedias()
      })
      uploadPromise = uploadPromise.catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        } else {
          dispatch(errorLoading('Error.Croutons.uploadFail'))
        }
      })
    }
  }

  function uploadIconSet() {
    if (file) {
      let entryPoint = Constants.UrlsConstants.iconUploadEntryPoint
      let formData = new FormData()
      formData.append('file', file)

      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
      }
      dispatch(uploading())

      return fetch(urlServer + entryPoint, {
        method: 'POST',
        body: formData,
        headers,
      })
        .then(res => progress(res.body, res))
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        // .then(r => r.json())
        .then(() => {
          dispatch(loaded('Error.Croutons.uploadSuccess'))
          dispatch(uploadSuccess())
          dispatch(endUploading())
          fetchMediasActions(dispatch).fetchIconsTags()
        })
        .catch((error) => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          } else {
            dispatch(errorLoading('Error.Croutons.uploadFail'))
          }
        })
    }
  }

  function uploadImageSet() {
    if (file) {
      let entryPoint = Constants.UrlsConstants.imagesUploadEntryPoint
      let formData = new FormData()
      formData.append('file', file)

      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
      }
      dispatch(uploading())

      return fetch(urlServer + entryPoint, {
        method: 'POST',
        body: formData,
        headers,
      })
        .then(res => progress(res.body, res))
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        // .then(r => r.json())
        .then(() => {
          dispatch(loaded('Error.Croutons.uploadSuccess'))
          dispatch(uploadSuccess())
          dispatch(endUploading())
          fetchMediasActions(dispatch).fetchImagesTags()
        })
        .catch((error) => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          } else {
            dispatch(errorLoading('Error.Croutons.uploadFail'))
          }
        })
    }
  }

  function uploadWithBlobWithoutRedux() {
    if (appid && file) {
      let entryPoint = Constants.UrlsConstants.libraryEntryPoint
      let method = Constants.MethodsWSConstants.MEDIAS.ADD_MEDIA + appid
      let formData = new FormData()
      formData.append('file', file, filename !== null ? filename : 'Image.png')
      formData.append('typeMedia', Constants.AppsConstants.MEDIA.TYPE[0])

      let headers = {
        'authtoken': Constants.UrlsConstants.header.authtoken,
        'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
      }

      dispatch(uploading())
      return fetch(Constants.UrlsConstants.urlServer + entryPoint + method, {
        method: 'POST',
        body: formData,
        headers,
      })
    }
  }

  function uploadMedias() {

    console.log(Constants.UrlsConstants.urlServer + Constants.UrlsConstants.mediaUpload + appid);
    let headers = {
      'authtoken': Constants.UrlsConstants.header.authtoken,
      'refreshtoken': Constants.UrlsConstants.header.refreshtoken,
    }

    let zip = file && file[0];

    if (!zip) {
      return dispatch(errorLoading('Error.Croutons.authExpired'))
    }
    let formData = new FormData();
    formData.append('file', zip);
    dispatch(uploading())
    return fetch(Constants.UrlsConstants.urlServer + Constants.UrlsConstants.mediaUpload + appid, {
      method: 'POST',
      body: formData,
      headers,
    })
      .then(() => clearMediasActions(dispatch).clearMediasFromStore())
      .then(() => fetchMediasActions(dispatch, appid).fetchMedias())
      .then(() => dispatch(loaded('Error.Croutons.uploadSuccess')))
      .catch(() => dispatch(errorLoading('Error.Croutons.uploadFail')))

  }

  function downloadAllMedias() {
    window
      .open(Constants.UrlsConstants.urlServer + Constants.UrlsConstants.mediaDownloadAll + appid + '?authtoken=' + Constants.UrlsConstants.header.authtoken, '_blank');
  }

  function reinit() {
    dispatch(uploadReinit())
  }

  return {
    upload,
    reinit,
    uploadIconSet,
    uploadImageSet,
    uploadWithBlobWithoutRedux,
    uploadMedias,
    downloadAllMedias
  }
}
